import React from 'react';
import { useTranslation } from 'react-i18next';

const NoResults = ({ theme }) => {
  const { t } = useTranslation();
  
  return (
    <div className="col-sm-12 text-center">
      <p className="mb-0">
        <img
          alt="" // For accessibility
          style={{ width: "3.75rem", height: "3.75rem" }}
          src={`${process.env.PUBLIC_URL}/images/norecords.svg`}
        />
      </p>
      <p
        style={{
          textAlign: "center",
          fontWeight: "600",
          color: theme === "dark" ? "#fff" : "inherit",
        }}
      >
        {t("No records found")}
      </p>
    </div>
  );
};

export default NoResults;
